// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var Entity = require("../../common/types/Entity.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Types__User = require("../../user/Types__User.bs.js");
var NonEmptyList = require("../../common/types/NonEmptyList.bs.js");
var GraphQLHelpers = require("../../common/GraphQL/GraphQLHelpers.bs.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var ConversationEvent = require("./ConversationEvent.bs.js");
var Types__Attachment = require("../../common/types/Types__Attachment.bs.js");

var MessageSender = {};

function decode(raw) {
  if (raw.NAME !== "User") {
    return {
            TAG: /* Ok */0,
            _0: /* AnonymousUser */0
          };
  }
  var user = raw.VAL;
  if (user.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: /* User */{
              _0: user._0
            }
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: user._0
          };
  }
}

var Participant = {
  decode: decode
};

function make(participant, deliveredAt, readAt) {
  return {
          participant: participant,
          deliveredAt: deliveredAt,
          readAt: readAt
        };
}

function decode$1(obj) {
  var partial_arg = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeOption(GraphQLConverter.Helpers.parseUTCDateFromFloat, obj.readAt));
  var partial_arg$1 = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeOption(GraphQLConverter.Helpers.parseUTCDateFromFloat, obj.deliveredAt));
  var partial_arg$2 = GraphQLConverter.Helpers.someOk(Belt_Option.map(obj.participant, decode), "participant was None");
  var partial_arg$3 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$2, param);
  };
  var partial_arg$4 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$3, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(make)(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$4, partial_arg, param);
            });
}

var ppx_printed_query = "fragment conversationMessageStatus on ConversationMessageStatus   {\nid  \nparticipant  {\n__typename\n...on User   {\n..." + Types__User.Fragment.User.name + "   \n}\n\n...on AnonymousUser   {\nid  \n}\n\n}\n\ndeliveredAt  \nreadAt  \n}\n" + Types__User.Fragment.User.query;

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "id");
    var field_id = value$3 !== undefined ? Caml_option.valFromOption(value$3) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$4 = Js_dict.get(value$2, "participant");
    var field_participant;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      if (value$5 == null) {
        field_participant = undefined;
      } else {
        var typename_obj = Js_json.decodeObject(value$5);
        var tmp$1;
        if (typename_obj !== undefined) {
          var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
          if (typename !== undefined) {
            var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
            if (typename$1 !== undefined) {
              switch (typename$1) {
                case "AnonymousUser" :
                    tmp$1 = {
                      NAME: "AnonymousUser",
                      VAL: {
                        id: value$5["id"]
                      }
                    };
                    break;
                case "User" :
                    tmp$1 = {
                      NAME: "User",
                      VAL: Curry._1(Types__User.Fragment.User.parse, value$5)
                    };
                    break;
                default:
                  tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
              }
            } else {
              tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
            }
          } else {
            tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
          }
        } else {
          tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
        }
        field_participant = tmp$1;
      }
    } else {
      field_participant = undefined;
    }
    var value$6 = Js_dict.get(value$2, "deliveredAt");
    var field_deliveredAt;
    if (value$6 !== undefined) {
      var value$7 = Caml_option.valFromOption(value$6);
      field_deliveredAt = (value$7 == null) ? undefined : Caml_option.some(value$7);
    } else {
      field_deliveredAt = undefined;
    }
    var value$8 = Js_dict.get(value$2, "readAt");
    var field_readAt;
    if (value$8 !== undefined) {
      var value$9 = Caml_option.valFromOption(value$8);
      field_readAt = (value$9 == null) ? undefined : Caml_option.some(value$9);
    } else {
      field_readAt = undefined;
    }
    tmp = {
      id: field_id,
      participant: field_participant,
      readAt: field_readAt,
      deliveredAt: field_deliveredAt
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$1(tmp);
}

var name = "conversationMessageStatus";

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var ConversationMessageStatus = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: name,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Status = {
  make: make,
  decode: decode$1,
  ConversationMessageStatus: ConversationMessageStatus
};

function senderIsUser(message, userId) {
  var t = message.sender;
  if (t) {
    return t._0.id === userId;
  } else {
    return false;
  }
}

function decodeAttachments(param) {
  return GraphQLConverter.Helpers.decodeOption((function (param) {
                return GraphQLConverter.Helpers.decodeArray((function (i) {
                              return i;
                            }), param);
              }), param);
}

function decode$2(obj) {
  var partial_arg = GraphQLConverter.Helpers.ok(obj.files);
  var partial_arg$1 = GraphQLConverter.Helpers.ok(obj.images);
  var partial_arg$2 = GraphQLConverter.Helpers.ok(obj.status);
  var partial_arg$3 = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.parseUTCDateFromFloat(obj.sentAt));
  var partial_arg$4 = GraphQLConverter.Helpers.ok(obj.sender);
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$3, param);
  };
  var partial_arg$7 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg$2, param);
  };
  var partial_arg$8 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$7, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (sender, sentAt, status, images, files) {
                return {
                        id: obj.id,
                        sentAt: sentAt,
                        text: obj.text,
                        images: NonEmptyList.fromArray(Belt_Option.getWithDefault(images, [])),
                        files: NonEmptyList.fromArray(Belt_Option.getWithDefault(files, [])),
                        sender: sender,
                        status: Belt_List.fromArray(status)
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$8, partial_arg, param);
            });
}

function decodeStatuses(param) {
  return GraphQLConverter.Helpers.decodeArray((function (i) {
                return i;
              }), param);
}

var ppx_printed_query$1 = "fragment conversationMessage on ConversationMessage   {\nid  \nsentAt  \ntext  \nimages  {\n..." + Types__Attachment.Fragment.DecodedAttachment.name + "   \n}\n\nfiles  {\n..." + Types__Attachment.Fragment.DecodedAttachment.name + "   \n}\n\nsender  {\n..." + Types__User.Fragment.User.name + "   \n}\n\nstatus  {\n..." + name + "   \n}\n\n}\n" + ppx_printed_query + Types__Attachment.Fragment.DecodedAttachment.query + Types__User.Fragment.User.query;

function parse$1(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "id");
    var field_id = value$3 !== undefined ? Caml_option.valFromOption(value$3) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$4 = Js_dict.get(value$2, "sentAt");
    var field_sentAt = value$4 !== undefined ? Caml_option.valFromOption(value$4) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$5 = Js_dict.get(value$2, "text");
    var field_text;
    if (value$5 !== undefined) {
      var value$6 = Caml_option.valFromOption(value$5);
      field_text = (value$6 == null) ? undefined : value$6;
    } else {
      field_text = undefined;
    }
    var value$7 = Js_dict.get(value$2, "images");
    var field_images;
    if (value$7 !== undefined) {
      var value$8 = Caml_option.valFromOption(value$7);
      field_images = decodeAttachments(!(value$8 == null) ? Js_array.map((function (value) {
                    return Curry._1(Types__Attachment.Fragment.DecodedAttachment.parse, value);
                  }), value$8) : undefined);
    } else {
      field_images = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    var value$9 = Js_dict.get(value$2, "files");
    var field_files;
    if (value$9 !== undefined) {
      var value$10 = Caml_option.valFromOption(value$9);
      field_files = decodeAttachments(!(value$10 == null) ? Js_array.map((function (value) {
                    return Curry._1(Types__Attachment.Fragment.DecodedAttachment.parse, value);
                  }), value$10) : undefined);
    } else {
      field_files = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    var value$11 = Js_dict.get(value$2, "sender");
    var field_sender;
    if (value$11 !== undefined) {
      var value$12 = Caml_option.valFromOption(value$11);
      field_sender = Types__User.decodeMaybeAnonymousUser(!(value$12 == null) ? Curry._1(Types__User.Fragment.User.parse, value$12) : undefined);
    } else {
      field_sender = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    var value$13 = Js_dict.get(value$2, "status");
    var field_status;
    if (value$13 !== undefined) {
      var param = Js_array.map(parse, Caml_option.valFromOption(value$13));
      field_status = GraphQLConverter.Helpers.decodeArray((function (i) {
              return i;
            }), param);
    } else {
      field_status = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    tmp = {
      id: field_id,
      sentAt: field_sentAt,
      text: field_text,
      images: field_images,
      files: field_files,
      sender: field_sender,
      status: field_status
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode$2(tmp);
}

var name$1 = "conversationMessage";

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var ConversationMessage = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  name: name$1,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

var Message = {
  Status: Status,
  senderIsUser: senderIsUser,
  decodeAttachments: decodeAttachments,
  decode: decode$2,
  decodeStatuses: decodeStatuses,
  ConversationMessage: ConversationMessage
};

var Messages = {};

function decodeMaybeAnonymousUsers(arr) {
  return Belt_List.fromArray(Utils.$$Array.uniq(Belt_Array.keepMap(Belt_Array.map(arr, (function (x) {
                            if (x.NAME === "User") {
                              return Belt_Result.map(x.VAL, (function (u) {
                                            return /* User */{
                                                    _0: u
                                                  };
                                          }));
                            } else {
                              return {
                                      TAG: /* Ok */0,
                                      _0: /* AnonymousUser */0
                                    };
                            }
                          })), Utils.Result.toOption), (function (x) {
                    if (x) {
                      return x._0.id;
                    } else {
                      return "anonymous";
                    }
                  })));
}

function decode$3(obj) {
  return obj.participants;
}

var ppx_printed_query$2 = "fragment ConversationParticipants on Conversation   {\nid  \nparticipants  {\n__typename\n...on User   {\n..." + Types__User.Fragment.User.name + "   \n}\n\n...on AnonymousUser   {\nid  \n}\n\n}\n\n}\n" + Types__User.Fragment.User.query;

function parse$2(value) {
  var value$1 = value["participants"];
  var tmp = {
    id: value["id"],
    participants: decodeMaybeAnonymousUsers(Js_array.map((function (value) {
                var typename_obj = Js_json.decodeObject(value);
                if (typename_obj === undefined) {
                  return Js_exn.raiseError("Unexpected GraphQL query response");
                }
                var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
                if (typename === undefined) {
                  return Js_exn.raiseError("Unexpected GraphQL query response");
                }
                var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
                if (typename$1 === undefined) {
                  return Js_exn.raiseError("Unexpected GraphQL query response");
                }
                switch (typename$1) {
                  case "AnonymousUser" :
                      return {
                              NAME: "AnonymousUser",
                              VAL: {
                                id: value["id"]
                              }
                            };
                  case "User" :
                      return {
                              NAME: "User",
                              VAL: Curry._1(Types__User.Fragment.User.parse, value)
                            };
                  default:
                    return Js_exn.raiseError("Unexpected GraphQL query response");
                }
              }), value$1))
  };
  return tmp.participants;
}

function ret_type$2(f) {
  return {};
}

var MT_Ret$2 = {};

var ConversationParticipants = {
  ppx_printed_query: ppx_printed_query$2,
  query: ppx_printed_query$2,
  parse: parse$2,
  name: "ConversationParticipants",
  ret_type: ret_type$2,
  MT_Ret: MT_Ret$2
};

var Participants = {
  decodeMaybeAnonymousUsers: decodeMaybeAnonymousUsers,
  decode: decode$3,
  ConversationParticipants: ConversationParticipants,
  Fragment: undefined
};

function isAnonymousMatch(x) {
  if (x.TAG === /* PrivateProperty */1) {
    return x._0.property.anonymousMatching;
  } else {
    return false;
  }
}

function getMatches(x) {
  var exit = 0;
  switch (x.TAG | 0) {
    case /* PublicProperty */0 :
    case /* PrivateProperty */1 :
        exit = 1;
        break;
    case /* PublicBuyerNeed */2 :
    case /* PrivateBuyerNeed */3 :
        exit = 2;
        break;
    case /* RentalProperty */4 :
        return {
                NAME: "RENTER_MATCHES",
                VAL: Belt_Array.keep(x._0.usersMatches, (function (m) {
                        var status = m.rentalNeed.status.status;
                        if (typeof status === "number" ? status === 0 : true) {
                          return !m.dismissed;
                        } else {
                          return false;
                        }
                      }))
              };
    case /* RentalNeed */5 :
        return {
                NAME: "RENTAL_OWNER_MATCHES",
                VAL: Belt_Array.keep(x._0.usersMatches, (function (m) {
                        var status = m.rentalProperty.status.listingStatus;
                        if (typeof status === "number" ? status === 0 : true) {
                          return !m.dismissed;
                        } else {
                          return false;
                        }
                      }))
              };
    case /* BroadcastMessage */6 :
        return "CONTEXT_WITHOUT_MATCHES";
    
  }
  switch (exit) {
    case 1 :
        return {
                NAME: "BUYER_MATCHES",
                VAL: Belt_Array.keep(Belt_Array.keep(x._0.usersMatches, (function (m) {
                            var status = m.buyerNeed.status.status;
                            if (typeof status === "number") {
                              return status === 0;
                            } else {
                              return true;
                            }
                          })), (function (m) {
                        return !m.dismissed;
                      }))
              };
    case 2 :
        return {
                NAME: "SELLER_MATCHES",
                VAL: Belt_Array.keep(Belt_Array.keep(x._0.usersMatches, (function (m) {
                            var status = m.property.status.listingStatus;
                            if (typeof status === "number") {
                              if (status === /* Active */0) {
                                return true;
                              } else {
                                return false;
                              }
                            } else if (status.TAG === /* Expiring */0) {
                              return true;
                            } else {
                              return false;
                            }
                          })), (function (m) {
                        return !m.dismissed;
                      }))
              };
    
  }
}

function getId(x) {
  switch (x.TAG | 0) {
    case /* PublicBuyerNeed */2 :
    case /* PrivateBuyerNeed */3 :
        return x._0.buyerNeed.id;
    case /* PublicProperty */0 :
    case /* PrivateProperty */1 :
    case /* RentalProperty */4 :
        return x._0.property.id;
    case /* RentalNeed */5 :
        return x._0.rentalNeed.id;
    case /* BroadcastMessage */6 :
        return x._0.id;
    
  }
}

function getEntityType(x) {
  switch (x.TAG | 0) {
    case /* PublicProperty */0 :
    case /* PrivateProperty */1 :
        return /* Property */0;
    case /* PublicBuyerNeed */2 :
    case /* PrivateBuyerNeed */3 :
        return /* BuyerNeed */1;
    case /* RentalProperty */4 :
        return /* RentalProperty */2;
    case /* RentalNeed */5 :
        return /* RentalNeed */3;
    case /* BroadcastMessage */6 :
        return /* BroadcastMessage */4;
    
  }
}

function getOwner(x) {
  switch (x.TAG | 0) {
    case /* PublicProperty */0 :
    case /* PrivateProperty */1 :
        return x._0.property.agent;
    case /* PublicBuyerNeed */2 :
    case /* PrivateBuyerNeed */3 :
        return /* User */{
                _0: x._0.buyerNeed.agent
              };
    case /* RentalProperty */4 :
    case /* RentalNeed */5 :
        return /* User */{
                _0: x._0.agent
              };
    case /* BroadcastMessage */6 :
        return /* User */{
                _0: x._0.agent
              };
    
  }
}

function isRemoved(x) {
  switch (x.TAG | 0) {
    case /* PublicProperty */0 :
    case /* PrivateProperty */1 :
        return x._0.property.status.listingStatus === 3;
    case /* PublicBuyerNeed */2 :
    case /* PrivateBuyerNeed */3 :
        return x._0.buyerNeed.status.status === 4;
    case /* RentalProperty */4 :
        var match = x._0.property.status.listingStatus;
        if (typeof match === "number") {
          return match >= 4;
        } else {
          return false;
        }
    case /* RentalNeed */5 :
        var match$1 = x._0.rentalNeed.status.status;
        if (typeof match$1 === "number") {
          return match$1 >= 4;
        } else {
          return false;
        }
    case /* BroadcastMessage */6 :
        return false;
    
  }
}

var Context = {
  isAnonymousMatch: isAnonymousMatch,
  getMatches: getMatches,
  getId: getId,
  getEntityType: getEntityType,
  getOwner: getOwner,
  isRemoved: isRemoved
};

function isRemoved$1(x) {
  switch (x.TAG | 0) {
    case /* PublicPropertySummary */0 :
    case /* PrivatePropertySummary */1 :
        return x._0.status.listingStatus === 3;
    case /* PublicBuyerNeedSummary */2 :
    case /* PrivateBuyerNeedSummary */3 :
        return x._0.status.status === 4;
    case /* RentalPropertySummary */4 :
        var match = x._0.status.listingStatus;
        if (typeof match === "number") {
          return match >= 4;
        } else {
          return false;
        }
    case /* RentalNeedSummary */5 :
        var match$1 = x._0.status.status;
        if (typeof match$1 === "number") {
          return match$1 >= 4;
        } else {
          return false;
        }
    case /* BroadcastMessageSummary */6 :
        return x._0.status === "DELETED";
    
  }
}

var ContextSummary = {
  isRemoved: isRemoved$1
};

var ConversationSummary = {};

function idToString(x) {
  if (x.TAG === /* Existing */0) {
    return x._0;
  } else {
    return Entity.Type.toString(x._0) + (":" + x._1);
  }
}

function unreadByUser(userId, message) {
  if (senderIsUser(message, userId)) {
    return false;
  } else {
    return Belt_List.some(message.status, (function (param) {
                  var participant = param.participant;
                  if (participant && param.readAt === undefined) {
                    return userId === participant._0.id;
                  } else {
                    return false;
                  }
                }));
  }
}

function countUnread(currentUserId, messages) {
  return Belt_List.reduce(Belt_List.map(messages, (function (v) {
                    if (unreadByUser(currentUserId, v)) {
                      return 1;
                    } else {
                      return 0;
                    }
                  })), 0, (function (prim0, prim1) {
                return prim0 + prim1 | 0;
              }));
}

function defaultToFalse(__x) {
  return Belt_Option.getWithDefault(__x, false);
}

function decodeWithoutContext(obj) {
  var messages = Belt_Array.keepMap(obj.messages, Utils.Result.toOption);
  var partial_arg = GraphQLConverter.Helpers.$$const(obj.participants);
  var partial_arg$1 = GraphQLConverter.Helpers.$$const(Belt_List.fromArray(Belt_Option.getWithDefault(obj.events, [])));
  var partial_arg$2 = GraphQLConverter.Helpers.$$const(Belt_List.fromArray(messages));
  var partial_arg$3 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$2, param);
  };
  var partial_arg$4 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$3, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (messages, events, participants) {
                return {
                        id: {
                          TAG: /* Existing */0,
                          _0: obj.id
                        },
                        visibility: obj.visibility,
                        readOnly: obj.readOnly,
                        anonymous: obj.anonymous,
                        context: undefined,
                        participants: participants,
                        messages: messages,
                        events: events
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$4, partial_arg, param);
            });
}

function decodeMaybeAnonymousUsers$1(arr) {
  return Belt_List.fromArray(Utils.$$Array.uniq(Belt_Array.keepMap(Belt_Array.map(arr, (function (x) {
                            if (x.NAME === "User") {
                              return Belt_Result.map(x.VAL, (function (u) {
                                            return /* User */{
                                                    _0: u
                                                  };
                                          }));
                            } else {
                              return {
                                      TAG: /* Ok */0,
                                      _0: /* AnonymousUser */0
                                    };
                            }
                          })), Utils.Result.toOption), (function (x) {
                    if (x) {
                      return x._0.id;
                    } else {
                      return "anonymous";
                    }
                  })));
}

var ppx_printed_query$3 = "fragment conversationWithoutContext on Conversation   {\nid  \nvisibility  \nanonymous  \nreadOnly  \nparticipants  {\n__typename\n...on User   {\n..." + Types__User.Fragment.User.name + "   \n}\n\n...on AnonymousUser   {\nid  \n}\n\n}\n\nmessages  {\n..." + name$1 + "   \n}\n\nevents  {\n..." + ConversationEvent.ConversationEvent.name + "   \n}\n\n}\n" + ConversationEvent.ConversationEvent.query + ppx_printed_query$1 + Types__User.Fragment.User.query;

function parse$3(value) {
  var value$1 = value["visibility"];
  var tmp = value$1 === "PUBLIC" ? "PUBLIC" : "PRIVATE";
  var value$2 = value["anonymous"];
  var value$3 = value["readOnly"];
  var value$4 = value["participants"];
  var value$5 = value["messages"];
  var value$6 = value["events"];
  return decodeWithoutContext({
              id: value["id"],
              visibility: tmp,
              anonymous: GraphQLHelpers.defaultToFalse(!(value$2 == null) ? value$2 : undefined),
              readOnly: Belt_Option.getWithDefault(!(value$3 == null) ? value$3 : undefined, false),
              participants: decodeMaybeAnonymousUsers$1(Js_array.map((function (value) {
                          var typename_obj = Js_json.decodeObject(value);
                          if (typename_obj === undefined) {
                            return Js_exn.raiseError("Unexpected GraphQL query response");
                          }
                          var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
                          if (typename === undefined) {
                            return Js_exn.raiseError("Unexpected GraphQL query response");
                          }
                          var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
                          if (typename$1 === undefined) {
                            return Js_exn.raiseError("Unexpected GraphQL query response");
                          }
                          switch (typename$1) {
                            case "AnonymousUser" :
                                return {
                                        NAME: "AnonymousUser",
                                        VAL: {
                                          id: value["id"]
                                        }
                                      };
                            case "User" :
                                return {
                                        NAME: "User",
                                        VAL: Curry._1(Types__User.Fragment.User.parse, value)
                                      };
                            default:
                              return Js_exn.raiseError("Unexpected GraphQL query response");
                          }
                        }), value$4)),
              messages: Js_array.map(parse$1, value$5),
              events: !(value$6 == null) ? Js_array.map((function (value) {
                        return ConversationEvent.ConversationEvent.parse(value);
                      }), value$6) : undefined
            });
}

function ret_type$3(f) {
  return {};
}

var MT_Ret$3 = {};

var ConversationWithoutContext = {
  ppx_printed_query: ppx_printed_query$3,
  query: ppx_printed_query$3,
  parse: parse$3,
  name: "conversationWithoutContext",
  ret_type: ret_type$3,
  MT_Ret: MT_Ret$3
};

var Fragments = {
  defaultToFalse: defaultToFalse,
  decodeWithoutContext: decodeWithoutContext,
  decodeMaybeAnonymousUsers: decodeMaybeAnonymousUsers$1,
  ConversationWithoutContext: ConversationWithoutContext
};

var Conversation = {
  idToString: idToString,
  unreadByUser: unreadByUser,
  countUnread: countUnread,
  Fragments: Fragments
};

var EntityType;

exports.EntityType = EntityType;
exports.MessageSender = MessageSender;
exports.Participant = Participant;
exports.Message = Message;
exports.Messages = Messages;
exports.Participants = Participants;
exports.Context = Context;
exports.ContextSummary = ContextSummary;
exports.ConversationSummary = ConversationSummary;
exports.Conversation = Conversation;
/* Utils Not a pure module */
